module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "tcd"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Out of the fog to larboard came a green serpent’s head big as a horse’s, with white dagger teeth fencing red mouth horrendously agape. With dreadful swiftness it lunged low past Fafhrd on its endless yellow neck, its lower jaw loudly scraping the deck, and the white daggers clashed on the black kitten."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Or rather, on where the kitten had just been. For the latter seemed not so much to leap as to lift itself, by its tail perhaps, onto the starboard rail and thence vanished into the fog at the top of the aftermast in at most three more bounds."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The helmsmen raced each other forward. Slinoor and the Mouser threw themselves against the starboard taffrail, the unmanned tiller swinging slowly above them affording some sense of protection against the monster, which now lifted its nightmare head and swayed it this way and that, each time avoiding Fafhrd by inches. Apparently it was searching for the black kitten or more like it."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd stood frozen, at first by sheer shock, then by the thought that whatever part of him moved first would get snapped off."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Nevertheless he was about to jump for it—besides all else the monster’s mere stench was horrible—when a second green dragon’s head, four times as big as the first with teeth like scimitars, came looming out of the fog. Sitting commandingly atop this second head was a man dressed in orange and purple, like a herald of the Eastern Lands, with red boots, cape and helmet, the last with a blue window in it, seemingly of opaque glass."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There is a point of grotesquerie beyond which horror cannot go, but slips into delirium. Fafhrd had reached that point. He began to feel as if he were in an opium dream. Everything was unquestionably real, yet it had lost its power to horrify him acutely."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He noticed as the merest of quaint details that the two greenish yellow necks forked from a common trunk."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Besides, the gaudily garbed man or demon riding the larger head seemed very sure of himself, which might or might not be a good thing. Just now he was belaboring the smaller head, seemingly in rebuke, with a blunt-pointed, blunt-hooked pike he carried, and roaring out, either under or through his blue-red helmet, a gibberish that might be rendered as:"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Gotterdammer Ungeheuer!”")]), _vm._v(" "), _c('i', [_vm._v("(“Goddam monster!” German is a language completely unknown in Nehwon")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The smaller head cringed away, whimpering like seventeen puppies. The man-demon whipped out a small book of pages and after consulting it twice (apparently he could see out through his blue window) called down in broken outlandishly accented Lankhmarese, “What world is this, friend?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd had never before in his life heard that question asked, even by an awakening brandy guzzler. Nevertheless in his opium-dream mood he answered easily enough, “The world of Nehwon, oh sorcerer!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Gott sei dank!")]), _vm._v("”("), _c('i', [_vm._v("“Thank God!”)")]), _vm._v(" the man-demon gibbered."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd asked, “What world do "), _c('i', [_vm._v("you")]), _vm._v(" hail from?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The question seemed to confound the man-demon. Hurriedly consulting his book, he replied, “Do you know about other worlds? Don’t you believe the stars are only huge jewels?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd responded, “Any fool can see that the lights in the sky are jewels, but we are not simpletons, we know of other worlds. The Lankhmarts think they’re bubbles in infinite waters. "), _c('i', [_vm._v("I")]), _vm._v(" believe we live in the jewel-ceilinged skull of a dead god. But doubtless there are other such skulls, the universe of universes being a great frosty battlefield.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The tiller, swinging as "), _c('i', [_vm._v("Squid")]), _vm._v(" wallowed with sail a-flap, bumped the lesser head, which twisted around and snapped at it, then shook splinters from its teeth."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tell the sorcerer to keep it off!” Slinoor shouted, cringing."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After more hurried page-flipping the man-demon called down, “Don’t worry, the monster seems to eat only rats. I captured it by a small rocky island where many rats live. It mistook your small black ship’s cat for a rat.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Still in his mood of opium-lucidity, Fafhrd called up, “Oh sorcerer, do you plan to conjure the monster to your own skull-world, or world-bubble?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This question seemed doubly to confound and excite the man-demon. He appeared to think Fafhrd must be a mind reader. With much frantic book-consulting, he explained that he came from a world called simply Tomorrow and that he was visiting many worlds to collect monsters for some sort of museum or zoo, which he called in his gibberish "), _c('i', [_vm._v("Hagenbecks Zeitgarten.( Literally, in German, “")]), _c('span', {
    staticClass: "s1"
  }, [_c('i', [_vm._v("Hagenbecks")])]), _c('i', [_vm._v(" Time garden,” apparently derived from ")]), _vm._v("Tiergarten"), _c('i', [_vm._v(", which means animal-garden, or zoo.)")]), _vm._v(" On this particular expedition he had been seeking a monster that would be a reasonable facsimile of a wholly mythical six-headed sea-monster that devoured men off the decks of ships and was called Scylla by an ancient fantasy writer named Homer."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There never was a Lankhmar poet named Homer,” muttered Slinoor."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Doubtless he was a minor scribe of Quarmall or the Eastern Lands,” the Mouser told Slinoor reassuringly. Then, grown less fearful of the two heads and somewhat jealous of Fafhrd holding the center of the stage, the Mouser leapt atop the taffrail and cried, “Oh, sorcerer, with what spells will you conjure your Little Scylla back to, or perhaps I should say ahead to your Tomorrow bubble? I myself know somewhat of witchcraft. Desist, vermin!” This last remark was directed with a gesture of lordly contempt toward the lesser head, which came questing curiously toward the Mouser. Slinoor gripped the Mouser’s ankle."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man-demon reacted to the Mouser’s question by slapping himself on the side of his red helmet, as though he’d forgotten something most important. He hurriedly began to explain that he traveled between worlds in a ship (or space-time engine, whatever that might mean) that tended to float just above the water—“a black ship with little lights and masts”—and that the ship had floated away from him in another fog a day ago while he’d been absorbed in taming the newly captured sea-monster. Since then the man-demon, mounted on his now-docile monster, had been fruitlessly searching for his lost vehicle."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The description awakened a memory in Slinoor, who managed to nerve himself to explain audibly that last sunset "), _c('i', [_vm._v("Squid")]), _vm._v("’s crow’s nest had sighted just such a ship floating or flying to the northeast."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man-demon was voluble in his thanks and after questioning Slinoor closely announced (rather to everyone’s relief) that he was now ready to turn his search eastward with new hope."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Probably I will never have the opportunity to repay your courtesies,” he said in parting. “But as you drift through the waters of eternity at least carry with you my name: Karl Treuherz of "), _c('i', [_vm._v("Hagenbecks")]), _vm._v(".”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hisvet, who had been listening from the middeck, chose that moment to climb the short ladder that led up to the afterdeck. She was wearing an ermine smock and hood against the chilly fog.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As her silvery hair and pale lovely features rose above the level of the afterdeck the smaller dragon’s head, which had been withdrawing decorously, darted at her with the speed of a serpent striking. Hisvet dropped. Woodwork rended loudly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Backing out into the fog atop the larger and rather benign-eyed head, Karl Treuherz gibbered as never before and belabored the lesser head mercilessly as it withdrew."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then the two-headed monster with its orange-and-purple mahout could be dimly seen moving around "), _c('i', [_vm._v("Squid")]), _vm._v("’s stern eastward into thicker fog, the man-demon gibbering gentlier what might have been an excuse and farewell: "), _c('i', [_vm._v("“Es tut mir sehr leid! Aber danke schoen, danke schoen!” (It was: “I am so very sorry! But thank you, thank you so nicely!”)")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With a last gentle"), _c('i', [_vm._v(" “Hoongk!”")]), _vm._v(" the man-demon dragon-dragon assemblage faded into the fog."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd and the Mouser raced a tie to Hisvet’s side, vaulting down over the splintered rail, only to have her scornfully reject their solicitude as she lifted herself from the oaken middeck, delicately rubbing her hip and limping for a step or two.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Come not near me, Spoonmen,” she said bitterly. “Shame it is when a Demoiselle must save herself from toothy perdition only by falling helter-skelter on that part of her which I would almost shame to show you on Frix. You are no gentle knights, else dragons’ heads had littered the after-deck. Fie, fie!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Meanwhile patches of clear sky and water began to show to the west and the wind to freshen from the same quarter. Slinoor dashed forward, bawling for his bosun to chase the monster-scared sailors up from the forecastle before "), _c('i', [_vm._v("Squid")]), _vm._v(" did herself an injury. Although there was yet little real danger of that, the Mouser stood by the tiller, Fafhrd looked to the mainsheet. Then Slinoor, hurrying back aft followed by a few pale sailors, sprang to the taffrail with a cry."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The fogbank was slowly rolling eastward. Clear water stretched to the western horizon. Two bowshots north of "), _c('i', [_vm._v("Squid")]), _vm._v(", four other ships were emerging in a disordered cluster from the white wall: the war galley "), _c('i', [_vm._v("Shark")]), _vm._v(" and the grain ships "), _c('i', [_vm._v("Tunny")]), _vm._v(", "), _c('i', [_vm._v("Carp")]), _vm._v(" and "), _c('i', [_vm._v("Grouper")]), _vm._v(". The galley, moving rapidly under oars, was headed toward "), _c('i', [_vm._v("Squid")]), _vm._v("."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Slinoor was staring south. There, a scant bowshot away, were two ships, the one standing clear of the fog-bank, the other half hid in it."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The one in the clear was "), _c('i', [_vm._v("Clam")]), _vm._v(", about to sink by the head, its gunwales awash. Its mainsail, somehow carried away, trailed brownly in the water. The empty deck was weirdly arched upward."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The fog-shrouded ship appeared to be a black cutter with a black sail."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Between the two ships, from "), _c('i', [_vm._v("Clam")]), _vm._v(" toward the cutter, moved a multitude of tiny, dark-headed ripples."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd joined Slinoor. Without looking away, the latter said simply, “Rats!” Fafhrd’s eyebrows rose."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser joined them, saying, “"), _c('i', [_vm._v("Clam")]), _vm._v("’s holed. The water swells the grain, which mightily forces up the deck.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor nodded and pointed toward the cutter. It was possible dimly to see tiny dark forms—rats surely!—climbing over its side from out of the water. “There’s what gnawed holes in "), _c('i', [_vm._v("Clam")]), _vm._v(",” Slinoor said."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then Slinoor pointed between the ships, near the cutter. Among the last of the ripple-army was a white-headed one. A second later a small white form could be seen swiftly mounting the cutter’s side. Slinoor said, “There’s what commanded the hole-gnawers.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With a dull splintering rumble the arched deck of "), _c('i', [_vm._v("Clam")]), _vm._v(" burst upward, spewing brown."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The grain!” Slinoor cried hollowly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now you know what tears ships,” the Mouser said."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The black cutter grew ghostlier, moving west now into the retreating fog."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The galley "), _c('i', [_vm._v("Shark")]), _vm._v(" went boiling past "), _c('i', [_vm._v("Squid")]), _vm._v("’s stern, its oars moving like the legs of a leaping centipede. Lukeen shouted up, “Here’s foul trickery! "), _c('i', [_vm._v("Clam")]), _vm._v(" was lured off in the night!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The black cutter, winning its race with the eastward-rolling fog, vanished in whiteness."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The split-decked "), _c('i', [_vm._v("Clam")]), _vm._v(" nosed under with hardly a ripple and angled down into the black and salty depths, dragged by its leaden keel."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With war trumpet skirling, "), _c('i', [_vm._v("Shark")]), _vm._v(" drove into the white wall after the cutter."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Clam")]), _vm._v("’s masthead, cutting a little furrow in the swell, went under. All that was to be seen now on the waters south of "), _c('i', [_vm._v("Squid")]), _vm._v(" was a great spreading stain of tawny grain."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor turned grim-faced to his mate. “Enter the Demoiselle Hisvet’s cabin, by force if need be,” he commanded. “Count her white rats!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd and the Mouser looked at each other."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tcd"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Three hours later the same four persons were assembled in Hisvet’s cabin with the Demoiselle, Frix and Lukeen."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The cabin, low-ceilinged enough so that Fafhrd, Lukeen and the mate must move bent and tended to sit hunch-shouldered, was spacious for a grain ship, yet crowded by this company together with the caged rats and Hisvet’s perfumed, silver-bound baggage piled on Slinoor’s dark furniture and locked sea chests."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Three horn windows to the stern and louver slits to starboard and larboard let in a muted light."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor and Lukeen sat against the horn windows, behind a narrow table. Fafhrd occupied a cleared sea chest, the Mouser an upended cask. Between them were racked the four rat-cages, whose white-furred occupants seemed as quietly intent on the proceedings as any of the men. The Mouser amused himself by imagining what it would be like if the white rats were trying the men instead of the other way round. A row of blue-eyed white rats would make most formidable judges, already robed in ermine. He pictured them staring down mercilessly from very high seats at a tiny cringing Lukeen and Slinoor, round whom scuttled mouse pages and mouse clerks and behind whom stood rat pikemen in half armor holding fantastically barbed and curvy-bladed weapons."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The mate stood stooping by the open grille of the closed door, in part to see that no other sailors eavesdropped."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Demoiselle Hisvet sat cross-legged on the swung-down sea-bed, her ermine smock decorously tucked under her knees, managing to look most distant and courtly even in this attitude. Now and again her right hand played with the dark wavy hair of Frix, who crouched on the deck at her knees."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Timbers creaked as "), _c('i', [_vm._v("Squid")]), _vm._v(" bowled north. Now and then the bare feet of the helmsmen could be heard faintly slithering on the afterdeck overhead. Around the small trapdoor-like hatches leading below and through the very crevices of the planking came the astringent, toastlike, all-pervasive odor of the grain."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen spoke. He was a lean, slant-shouldered, cordily muscled man almost as big as Fafhrd. His short coat of browned-iron mail over his simple black tunic was of the finest links. A golden band confined his dark hair and bound to his forehead the browned-iron five-pointed curvy-edged starfish emblem of Lankhmar."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How do I know "), _c('i', [_vm._v("Clam")]), _vm._v(" was lured away? Two hours before dawn I twice thought I heard "), _c('i', [_vm._v("Shark")]), _vm._v("’s own gong-note in the distance, although I stood then beside "), _c('i', [_vm._v("Shark")]), _vm._v("’s muffled gong. Three of my crew heard it too. ’Twas most eerie. Gentlemen, I know the gong-notes of Lankhmar war galleys and merchantmen better than I know my children’s voices. This that we heard was so like "), _c('i', [_vm._v("Shark")]), _vm._v("’s I never dreamed it might be that of another ship—I deemed it some ominous ghost-echo or trick of our minds and I thought no more about it as a matter for action. If I had only had the faintest suspicion ….”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen scowled bitterly, shaking his head, and continued, “Now I know the black cutter must carry a gong shaped to duplicate "), _c('i', [_vm._v("Shark")]), _vm._v("’s note precisely. They used it, likely with someone mimicking my voice, to draw "), _c('i', [_vm._v("Clam")]), _vm._v(" out of line in the fog and get her far enough off so that the rat-horde, officered by the white one, could work its will on her without the crew’s screams being heard. They must have gnawed twenty holes in her bottom for "), _c('i', [_vm._v("Clam")]), _vm._v(" to take on water so fast and the grain to swell so. Oh, they’re far shrewder and more persevering than men, the little spade-toothed fiends!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Midsea madness!” Fafhrd snorted in interruption. “Rats make men scream? And do away with them? Rats seize a ship and sink it? Rats officered and accepting discipline? Why this is the strangest superstition!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re a fine one to talk of superstition and the impossible, Fafhrd,” Slinoor shot at him, “when only this morning you talked with a masked and gibbering demon who rode a two-headed dragon.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen lifted his eyebrows at Slinoor. This was the first he’d heard of the Hagenbeck episode."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd said, “That was travel between worlds. Another matter altogether. No superstition in it.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor responded skeptically, “I suppose there was no superstition in it either when you told me what you’d heard from the Wise Woman about the Thirteen?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd laughed. “Why, I never believed one word the Wise Woman ever told me. She was a witchy old fool. I recounted her nonsense merely as a curiosity.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor eyed Fafhrd with slit-eyed incredulity, then said to Lukeen, “Continue.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s little more to tell,” the latter said. “I saw the rat-battalions swimming from "), _c('i', [_vm._v("Clam")]), _vm._v(" to the black cutter. I saw, as you did, their white officer.” This with a glare at Fafhrd. “Thereafter I fruitlessly hunted the black cutter two hours in the fog until cramp took my rowers. If I’d found her, I’d’ve not boarded her but thrown fire into her! Aye, and stood off the rats with burning oil on the waters if they tried again to change ships! Aye, and laughed as the furred murderers fried!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just so,” Slinoor said with finality. “And what, in your judgment, Commander Lukeen, should we do now?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sink the white archfiends in their cages,” Lukeen answered instantly, “before they order the rape of more ships, or our sailors go mad with fear.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This brought an instant icy retort from Hisvet. “You’ll have to sink me first, silver-weighted, oh Commander!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen’s gaze moved past her to a scatter of big-eared silver unguent jars and several looped heavy silver chains on a shelf by the bed. “That too is not impossible, Demoiselle,” he said, smiling hardly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s not one shred of proof against her!” Fafhrd exploded. “Little Mistress, the man is mad.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No proof?” Lukeen roared. “There were twelve white rats yesterday. Now there are eleven.” He waved a hand at the stacked cages and their blue-eyed haughty occupants. “You’ve all counted them. Who else but this devilish Demoiselle sent the white officer to direct the sharp-toothed gnawers and killers that destroyed "), _c('i', [_vm._v("Clam")]), _vm._v("? What more proof do you want?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, indeed!” the Mouser interjected in a high vibrant voice that commanded attention. “There is proof aplenty … "), _c('i', [_vm._v("if")]), _vm._v(" there were twelve rats in the four cages yesterday.” Then he added casually but very clearly, “It is my recollection that there were eleven.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor stared at the Mouser as though he couldn’t believe his ears. “You lie!” he said. “What’s more, you lie senselessly. Why, you and Fafhrd and I all spoke of there being twelve white rats!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser shook his head. “Fafhrd and I said no word about the exact number of rats. "), _c('i', [_vm._v("You")]), _vm._v(" said there were a dozen,” he informed Slinoor. “Not twelve, but … a dozen. I assumed you were using the expression as a round number, an approximation.” The Mouser snapped his fingers. “Now I remember that when you said a dozen I became idly curious and counted the rats. And got eleven. But it seemed to me too trifling a matter to dispute.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, there were twelve rats yesterday,” Slinoor asserted solemnly and with great conviction. “You’re mistaken, Gray Mouser.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll believe my friend Slinoor before a dozen of you,” Lukeen put in."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“True, friends should stick together,” the Mouser said with an approving smile. “Yesterday I counted Glipkerio’s gift-rats and got eleven. Ship’s Master Slinoor, any man may be mistaken in his recollections from time to time. Let’s analyze this. Twelve white rats divided by four silver cages equals three to a cage. Now let me see … I have it! There was a time yesterday when between us, we surely counted the rats—when we carried them down to this cabin. How many were in the cage you carried, Slinoor?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Three,” the latter said instantly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And three in mine,” the Mouser said."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And three in each of the other two,” Lukeen put in impatiently. “We waste time!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We certainly do,” Slinoor agreed strongly, nodding."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Wait!” said the Mouser, lifting a point-fingered hand. “There was a moment when all of us must have noticed how many rats there were in one of the cages Fafhrd carried—when he first lifted it up, speaking the while to Hisvet. Visualize it. He lifted it like this.” The Mouser touched his thumb to his third finger. “How many rats were in that cage, Slinoor?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor frowned deeply. “Two,” he said, adding instantly, “and four in the other.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You said three in each just now,” the Mouser reminded him."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I did not!” Slinoor denied. “Lukeen said that, not I.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, but you nodded, agreeing with him,” the Mouser said, his raised eyebrows the very emblem of innocent truth-seeking."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I agreed with him only that we wasted time,” Slinoor said. “And we do.” Just the same a little of the frown lingered between his eyes and his voice had lost its edge of utter certainty."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I see,” the Mouser said doubtfully. By stages he had begun to play the part of an attorney elucidating a case in court, striding about and frowning most professionally. Now he shot a sudden question: “Fafhrd, how many rats did you carry?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Five,” boldly answered the Northerner, whose mathematics were not of the sharpest, but who’d had plenty time to count surreptitiously on his fingers and to think about what the Mouser was up to. “Two in one cage, three in the other.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A feeble falsehood!” Lukeen scoffed. “The base barbarian would swear to anything to win a smile from the Demoiselle, who has him fawning.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s a foul lie!” Fafhrd roared, springing up and fetching his head such a great hollow thump on a deck beam that he clapped both hands to it and crouched in dizzy agony."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sit down, Fafhrd, before I ask you to apologize to the deck!” the Mouser commanded with heartless harshness. “This is solemn civilized court, no barbarous brawling session! Let’s see—three and three and five make … eleven. Demoiselle Hisvet!” He pointed an accusing finger straight between her red-irised eyes and demanded most sternly, “How many white rats did you bring aboard "), _c('i', [_vm._v("Squid")]), _vm._v("? The truth now and nothing but the truth!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Eleven,” she answered demurely. “La, but I’m joyed someone at last had the wit to ask me.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That I know’s not true!” Slinoor said abruptly, his brow once more clear. “Why didn’t I think of it before?—’twould have saved us all this bother of questions and counting. I have in this very cabin Glipkerio’s letter of commission to me. In it he speaks verbatim of entrusting to me the Demoiselle Hisvet, daughter of Hisvin, and twelve witty white rats. Wait, I’ll get it out and prove it to your faces!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No need, Ship’s Master,” Hisvet interposed. “I saw the letter writ and can testify to the perfect truth of your quotations. But most sadly, between the sending of the letter and my boarding of "), _c('i', [_vm._v("Squid")]), _vm._v(", poor Tchy was gobbled up by Glippy’s giant boarhound Bimbat.” She touched a slim finger to the corner of her eye and sniffed. “Poor Tchy, he was the most winsome of the twelve. ’Twas why I kept to my cabin the first two days.” Each time she spoke the name Tchy, the eleven caged rats chittered mournfully."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Is it Glippy you call our overlord?” Slinoor ejaculated, genuinely shocked. “Oh shameless one!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aye, watch your language, Demoiselle,” the Mouser warned severely, maintaining to the hilt his new role of austere inquisitor. “Any familiar relationship between you and our overlord the arch-noble Glipkerio Kistomerces does not come within the province of this court.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She lies like a shrewd subtle witch!” Lukeen asserted angrily. “Thumbscrew or rack, or perchance just a pale arm twisted high behind her back would get the truth from her fast enough!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hisvet turned and looked at him proudly. “I accept your challenge, Commander,” she said evenly, laying her right hand on her maid’s dark head. “Frix, reach out your naked hand, or whatever other part of you the brave gentleman wishes to torture.” The dark maid straightened her back. Her face was impassive, lips firmly pressed together, though her eyes searched around wildly. Hisvet continued to Slinoor and Lukeen, “If you know any Lankhmar law at all, you know that a virgin of the rank of Demoiselle is tortured only in the person of her maid, who proves by her steadfastness under extreme pain the innocence of her mistress.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What did I tell you about her?” Lukeen demanded of them all. “Subtle is too gross a term for her spiderwebby sleights!” He glared at Hisvet and said scornfully, his mouth a-twist, “Virgin!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hisvet smiled with cold long-suffering. Fafhrd flushed and although still holding his battered head, barely refrained from leaping up again. Lukeen looked at him with amusement, secure in his knowledge that he could bait Fafhrd at will and that the barbarian lacked the civilized wit to insult him deeply in return."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd stared thoughtfully at Lukeen from under his capping hands. Then he said, “Yes, you’re brave enough in armor, with your threats against girls and your hot imaginings of torture, but if you were without armor and had to prove your manhood with just one brave girl alone, you’d fall like a worm!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen shot up enraged and got himself such a clout from a deck beam that he squeaked shudderingly and swayed. Nevertheless he gripped blindly for his sword at his side. Slinoor grasped that wrist and pulled him down into his seat."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Govern yourself, Commander,” Slinoor implored sternly, seeming to grow in resolution as the rest quarreled and quibbled. “Fafhrd, no more dagger words. Gray Mouser, this is not your court but mine and we are not met to split the hairs of high law but to meet a present peril. Here and now this grain fleet is in grave danger. Our very lives are risked. Much more than that, Lankhmar’s in danger if Movarl gets not his gift-grain at this third sending. Last night "), _c('i', [_vm._v("Clam")]), _vm._v(" was foully murdered. Tonight it may be "), _c('i', [_vm._v("Grouper")]), _vm._v(" or "), _c('i', [_vm._v("Squid")]), _vm._v(", "), _c('i', [_vm._v("Shark")]), _vm._v(" even, or no less than all our ships. The first two fleets went warned and well guarded, yet suffered only total perdition.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He paused to let that sink in. Then, “Mouser, you’ve roused some small doubts in my mind by your eleven-twelving. But small doubts are nothing where home lives and home cities are in peril. For the safety of the fleet and of Lankhmar we’ll sink the white rats forthwith and keep close watch on the Demoiselle Hisvet to the very docks of Kvarch Nar.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Right!” the Mouser cried approvingly, getting in ahead of Hisvet. But then he instantly added, with the air of sudden brilliant inspiration, “"), _c('i', [_vm._v("Or")]), _vm._v(" … better yet … appoint Fafhrd and myself to keep unending watch not only on Hisvet but also on the eleven white rats. That way we don’t spoil Glipkerio’s gift and risk offending Movarl.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’d trust no one’s mere watching of the rats. They’re too tricksy,” Slinoor informed him. “The Demoiselle I intend to put on "), _c('i', [_vm._v("Shark")]), _vm._v(", where she’ll be more closely guarded. The grain is what Movarl wants, not the rats. He doesn’t know about them, so can’t be angered at not getting them.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But he does know about them,” Hisvet interjected. “Glipkerio and Movarl exchange weekly letters by albatross-post. La, but Nehwon grows smaller each year, Ship’s Master—ships are snails compared to the great winging mail-birds. Glipkerio wrote of the rats to Movarl, who expressed great delight at the prospective gift and intense anticipation of watching the White Shadows perform. Along with myself,” she added, demurely bending her head."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Also,” the Mouser put in rapidly, “I must firmly oppose—most regretfully, Slinoor—the transfer of Hisvet to another ship. Fafhrd’s and my commission from Glipkerio, which I can produce at any time, states in clearest words that we are to attend the Demoiselle at all times outside her private quarters. He makes us wholly responsible for her safety—and also for that of the White Shadows, which creatures our overlord states, again in clearest writing, that he prizes beyond their weight in jewels.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You can attend her in "), _c('i', [_vm._v("Shark")]), _vm._v(",” Slinoor told the Mouser curtly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll not have the barbarian on my ship!” Lukeen rasped, still squinting from the pain of his clout."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’d scorn to board such a tricked-out rowboat or oar-worm,” Fafhrd shot back at him, voicing the common barbarian contempt for galleys."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Also")]), _vm._v(",” the Mouser cut in again, loudly, with an admonitory gesture at Fafhrd, “it is my duty as a friend to warn you, Slinoor, that in your reckless threats against the White Shadows and the Demoiselle herself, you risk incurring the heaviest displeasure not only of our overlord but also of the most powerful grain-merchant in Lankhmar.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor answered most simply, “I think only of the City and the grain fleet. You know that,” but Lukeen, fuming, spat out a “Hah!” and said scornfully, “The Gray Fool has not grasped that it is Hisvet’s very father Hisvin who is behind the rat-sinkings, since he thereby grows rich with the extra nation’s-ransoms of grain he sells Glipkerio!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Quiet, Lukeen!” Slinoor commanded apprehensively. “This dubious guesswork of yours has no place here.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Guesswork? Mine?” Lukeen exploded. “It was "), _c('i', [_vm._v("your")]), _vm._v(" suggestion, Slinoor—Yes, and that Hisvin plots Glipkerio’s overthrow—Aye, and even that he’s in league with the Mingols! Let’s speak truth for once!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then speak it for yourself alone, Commander,” Slinoor said most sober-sharply. “I fear the blow’s disordered your brain. Gray Mouser, you’re a man of sense,” he appealed. “Can you not understand my one overriding concern? We’re alone with mass murder on the high seas. We must take measures against it. Oh, will none of you show some simple wit?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“La, and I will, Ship’s Master, since you ask it,” Hisvet said brightly, rising to her knees on the sea-bed as she turned toward Slinoor. Sunlight striking through a louver shimmered on her silver hair and gleamed from the silver ring confining it. “I’m but a girl, unused to problems of war and rapine, yet I have an all-explaining simple thought that I have waited in vain to hear voiced by one of you gentlemen, wise in the ways of violence."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Last night a ship was slain. You hang the crime on rats—small beasties which would leave a sinking ship in any case, which often have a few whites among them, and which only by the wildest stretch of imagination are picturable as killing an entire crew and vanishing their bodies. To fill the great gaps in this weird theory you make me a sinister rat-queen, who can work black miracles, and now even, it seems, create my poor doting daddy an all-powerful rat-emperor."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yet this morning you met a ship’s murderer if there ever was one and let him go honking off unchallenged. La, but the man-demon even confessed he’d been seeking a multi-headed monster that would snatch living men from a ship’s deck and devour them. Surely he lied when he said his this-world foundling ate small fry only, for it struck at me to devour me—and might earlier have snapped up any of you, except it was sated!"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“For what is more likely than that the two-head long-neck dragon ate all "), _c('i', [_vm._v("Clam")]), _vm._v("’s sailors off her deck, snaking them out of the forecastle and hold, if they fled there, like sweetmeats from a compartmented comfit-box, and then scratched holes in "), _c('i', [_vm._v("Clam")]), _vm._v("’s planking? Or perhaps more likely still, that "), _c('i', [_vm._v("Clam")]), _vm._v(" tore out her bottom on the Dragon Rocks in the fog and at the same time met the sea-dragon? These are sober possibilities, gentlemen, apparent even to a soft girl and asking no mind-stretch at all.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This startling speech brought forth an excited medley of reactions. Simultaneously the Mouser applauded, “A gem of princess-wit, Demoiselle; oh you’d make a rare strategist.” Fafhrd said stoutly, “Most lucid, Little Mistress, yet Karl Treuherz seemed to me an honest demon.” Frix told them proudly, “My mistress outthinks you all.” The mate at the door goggled at Hisvet and made the sign of the starfish. Lukeen snarled, “She conveniently forgets the black cutter,” while Slinoor cried them all down with, “Rat-queen you say jestingly? Rat-queen you are!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As the others grew silent at that dire accusation, Slinoor gazing grimly fearful at Hisvet, continued rapidly, “The Demoiselle has recalled to me by her speech the worst point against her. Karl Treuherz said his dragon, living by the Rat Rocks, ate only rats. It made no move to gobble us several men, though it had every chance, yet when Hisvet appeared it struck at her at once. It knew her true race.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor’s voice went shudderingly low. “Thirteen rats with the minds of men rule the whole rat race. That’s ancient wisdom from Lankhmar’s wisest seers. Eleven are these silver-furred silent sharpies, hearing our every word. The twelfth celebrates in the black cutter his conquest of "), _c('i', [_vm._v("Clam")]), _vm._v(". The thirteenth”—and he pointed finger—“is the silver-haired, red-eyed Demoiselle herself!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen slithered to his feet at that, crying, “Oh most shrewdly reasoned, Slinoor! And why does she wear such modest shrouding garb except to hide further evidence of the dread kinship? Let me but strip off that cloaking ermine smock and I’ll show you a white-furred body and ten small black dugs instead of proper maiden breasts!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As he came snaking around the table toward Hisvet, Fafhrd sprang up, also cautiously, and pinned Lukeen’s arms to his sides in a bear-hug, calling, “Nay, and you touch her, you die!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Meantime Frix cried, “The dragon was sated with "), _c('i', [_vm._v("Clam")]), _vm._v("’s crew, as my mistress told you. It wanted no more coarse-fibered men, but eagerly seized at my dainty-fleshed darling for a dessert mouthful!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lukeen wrenched around until his black eyes glared into Fafhrd’s green ones inches away. “Oh most foul barbarian!” he grated. “I forego rank and dignity and challenge you this instant to a bout of quarterstaves on middeck. I’ll prove Hisvet’s taint on you by trial of battle. That is, if you dare face civilized combat, you great stinking ape!” And he spat full in Fafhrd’s taunting face."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd’s only reaction was to smile a great smile through the spittle running gummily down his cheek, while maintaining his grip of Lukeen and wary lookout for a bite at his own nose."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thereafter, challenge having been given and accepted, there was naught for even the head-shaking, heaven-glancing Slinoor to do but hurry preparation for the combat or duel, so that it might be fought before sunset and leave some daylight for taking sober measures for the fleet’s safety in the approaching dark of night."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As Slinoor, the Mouser and mate came around them, Fafhrd released Lukeen, who scornfully averting his gaze instantly went on deck to summon a squad of his marines from "), _c('i', [_vm._v("Shark")]), _vm._v(" to second him and see fair play. Slinoor conferred with his mate and other officers. The Mouser, after a word with Fafhrd, slipped forward and could be seen gossiping industriously with "), _c('i', [_vm._v("Squid’")]), _vm._v("s bosun and the common members of her crew down to cook and cabin boy. Occasionally something might have passed rapidly from the Mouser’s hand to that of the sailor with whom he spoke."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ab6361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0